<script>
  import { translate } from "../../i18n/i18next.js";
  import { onMount, tick } from "svelte";
  import { buildQueryString, parseAdvancedFilterObjString } from "../../utils/filter.js";

  /**
   * Called when the filter query is determined.
   * the query is considered determined in the following cases:
   *   * onblur event is triggered on the input
   *   * Enter is pressed on the input
   *   * One of the candidates is clicked
   * @param {string} query
   */

  /**
   * Optional prop that will be used to determine a candidate's match to the query.
   * If left unspecified, partial string match will be used.
   * @param {string} query
   */

  // noinspection JSUnusedGlobalSymbols
  /**
   * Can be used to set the query string from outside.
   * Note that this does not trigger onQueryDetermined().
   */
  export function setQuery(newQuery) {
    query = buildQueryString(newQuery)
  }

  // internal states
  export let title = ""
  export let query = ""
  export let option_length  = 0;
  export let onClickShowDialog;
  let inputEl = null;
  let displayQuery = "";
  $: {
    if (query) {
      if (query.length === option_length) {
        displayQuery = "フィルタなし"
      } else if (query.length === 1) {
        displayQuery = query
      } else if (query.length > 1 && query.length < option_length){
        displayQuery = query.length + "項目"
      } else{
        displayQuery = "ー"
      }
    }

  }

  // move the cursor to the end of the input to display the right-most part of the text
  function clipLeft() {
    if (inputEl) {
      inputEl.selectionStart = inputEl.selectionEnd = inputEl.value.length
    }
  }

  let innerContainerDiv = null
  let choicesContainerWidth = 0

  let inputWidth = 0
  $: {
  const ctx = document.createElement('canvas').getContext('2d');
  if (inputEl) {
    const computed = getComputedStyle(inputEl);
    ctx.font = `${computed.fontSize} ${computed.fontFamily}`;
    inputWidth = ctx.measureText(displayQuery).width+8;
  }
}



  onMount(async () => {
    await tick()
    clipLeft()
  })
</script>

<div class="filter-input-container" on:click={() => onClickShowDialog(title)}>
  <div class="filter-input-inner-container" class:with-title={title !== ""}  class:no-filter={query.length === option_length || query.length === 0} bind:this={innerContainerDiv}>
    {#if title}
      <div class="filter-title">
        {title} : 
      </div>
    {/if}
    <input
      class="filter-input"
      bind:value={displayQuery}
      bind:this={inputEl}
      style={"width: " + (inputWidth) + "px"}
      readonly
    />

    {#if title}
      {#if query.length === option_length || query.length === 0}
        <button>
          <img src="/assets/icon_page_down_blue.svg" alt="down arrow icon" style="width: 10px; height: 10px;"/>
        </button>
      {:else}
        <button>
          <img src="/assets/icon_page_down_white.svg" alt="down arrow icon" style="width: 10px; height: 10px;"/>
        </button>
      {/if}
    {:else if !title}
      <button>
        <img src="/assets/dropdown.svg" alt="down arrow icon" style="width: 14px; height: 14px;"/>
      </button>
    {/if}
  </div>
</div>

<style>
  button{
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    appearance: none;
  }
  .filter-title {
    color: white;
    white-space: nowrap;
  }
  .filter-input-container {
    position: relative;
    --border-color: #00468f;
    --hover-color: #00468f;
    --hover-text-color: white;
    cursor: pointer;
  }
  .filter-input-inner-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    border: solid 2px var(--border-color);
    border-radius: 6px;
    padding: 0 8px;
    gap: 8px;
    font-size: 12px;
    position: relative;
  }
  .filter-input-inner-container > input {
    flex: 1 1;
    line-height: 2;
    border: none;
    outline: none;
    overflow-x: clip;
    text-overflow: ellipsis;
    background-color: white;
    color: #00468f;
    max-width: 320px;
    cursor: pointer;
  }
  .filter-input-inner-container > input::placeholder {
    color: #a9a9a9;
  }
  .filter-input-inner-container.with-title {
    background-color: #00468f;
  }
  .filter-input-inner-container.with-title > input {
    background-color: #00468f;
    color: white;
  }

  .filter-input-inner-container.no-filter{
    background-color: white;
    color: #00468f;
  }

  .filter-input-inner-container.no-filter > input {
    color: #a9a9a9;
  }

  .filter-input-inner-container.no-filter > div {
    color: #00468f;
  }

  .filter-input-inner-container.no-filter > input,
  .filter-input-inner-container.no-filter > div {
    background-color: white;
  }

  .filter-input-inner-container img {
    cursor: pointer;
  }
</style>
